export default __webpack_public_path__ + "static/media/integration.0e07574b.svg";